import { API_BASE_URL } from './endpoints';

const buildUrl = (path) => `${API_BASE_URL}${path}`;

const parseJson = (text) => {
  if (!text) {
    return null;
  }
  try {
    return JSON.parse(text);
  } catch (error) {
    return null;
  }
};

const requestJson = async (path, options = {}) => {
  const { method = 'GET', body, token, headers = {} } = options;
  const url = buildUrl(path);
  const mergedHeaders = {
    'Content-Type': 'application/json',
    ...headers
  };

  if (token) {
    mergedHeaders.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(url, {
    method,
    headers: mergedHeaders,
    body: body === undefined ? undefined : JSON.stringify(body)
  });

  const text = await response.text();
  const payload = parseJson(text);

  if (!response.ok) {
    const message = payload && payload.message ? payload.message : `Request failed with status ${response.status}`;
    throw new Error(message);
  }

  return payload;
};

export const getJson = async (path, options = {}) => requestJson(path, { ...options, method: 'GET' });

export const postJson = async (path, body, options = {}) =>
  requestJson(path, { ...options, method: 'POST', body });

export const putJson = async (path, body, options = {}) =>
  requestJson(path, { ...options, method: 'PUT', body });

export const patchJson = async (path, body, options = {}) =>
  requestJson(path, { ...options, method: 'PATCH', body });
